import Header from "components/Headers/Header";
import { useDispatch, useSelector } from "react-redux";
import React, { useState } from "react";
import { Button, Card, Container, Modal, ModalBody } from "reactstrap";
import { getSingleBrandAmbassodarContest } from "store/actions/talkingBadgeAction";
import VoteGetter from "components/VoteGetter";
import { getSingleContestVideo } from "store/actions/talkingBadgeAction";
import BrandAmbassadorContestTab from "components/Contest/BrandAmbassadorContest";
import Tabs from "components/Tabs";
import image2 from "../../assets/img/custom/addvideoImge.png";
import HonorBadge from "components/HonorBadge";
import SportContest from "components/Contest/SportContest";

const Contest = () => {
  const dispatch = useDispatch();
  const { uid } = useSelector((state) => state.auth);
  const [badgeType, setBadgeType] = useState("");
  const [activeTab, setActiveTab] = useState("sportContest");
  const [winnerQrCode, setWinnerQrCode] = useState("");
  const [modal2, setModal2] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [brandAmbassadorId, setBrandAmbassadorId] = useState();
  const [brandAmbassadorData, setBrandAmbassadorData] = useState();
  const [modal, setModal] = useState(false);
  const toggle = () => {
    setModal(!modal);
  };
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };
  const toggleModal2 = () => {
    setModal2(!modal2);
  };
  const toggleModal1 = () => {
    setModal1(!modal1);
  };

  const getVoteGetterBadgeQuantity = (id) => {
    dispatch(getSingleBrandAmbassodarContest(id));
    dispatch(getSingleContestVideo(id, uid));
  };

  const tabs = [
    {
      id: "sportContest",
      title: "SPORT CONTEST",
      content: <SportContest />,
      onClick: () => {}
    },
    {
      id: "brandAmbassadorContest",
      title: "BRAND AMBASSADOR CONTEST",
      content: (
        <>
          <BrandAmbassadorContestTab
            activeTab={activeTab}
            setBadgeType={setBadgeType}
            setBrandAmbassadorId={setBrandAmbassadorId}
            toggleModal2={toggleModal2}
            getVoteGetterBadgeQuantity={getVoteGetterBadgeQuantity}
            setWinnerQrCode={setWinnerQrCode}
            setBrandAmbassadorData={setBrandAmbassadorData}
          />
        </>
      ),
      onClick: () => {}
    }
  ];

  return (
    <>
      <Header />
      <Container className="text-right px-4">
        <b className="pointer mr-2" onClick={toggle}>
          Great Video Info
        </b>
        <a
          target="_blank"
          href="https://firebasestorage.googleapis.com/v0/b/fans-help-players.appspot.com/o/SPORTS_CONTEST_RULES.docx?alt=media&token=36147886-af4e-498c-a0d8-93c3fcf32bc0"
        >
          <Button color="primary">Contest Rules</Button>
        </a>
      </Container>
      <Card className="m-4 pb-2">
        <Tabs activeTab={activeTab} toggleTab={toggleTab} tabs={tabs} />
      </Card>
      <HonorBadge
        toggle={toggleModal1}
        addModal={modal1}
        Id={brandAmbassadorId}
        winnerQrCode={winnerQrCode}
      />

      <VoteGetter
        activeTab={activeTab}
        toggle={toggleModal2}
        addModal={modal2}
        Id={brandAmbassadorId}
        type={badgeType}
        winnerQrCode={winnerQrCode}
        setWinnerQrCode={setWinnerQrCode}
        brandAmbassadorData={brandAmbassadorData}
      />
      <Modal
        isOpen={modal}
        toggle={toggle}
        size="md"
        className="modal-dialog modal-dialog-centered"
      >
        <ModalBody>
          <img src={image2} alt="" width="100%" />
          <div className="text-right">
            <Button color="primary" onClick={toggle}>
              Ok
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default Contest;
